// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { signIn, confirmSignIn } from 'aws-amplify/auth';
import styles from './LoginPage.module.css';
import '../styles/global.css';

export default function LoginPage() {
  const [formData, setFormData] = useState({ email: '', password: '', newPassword: '' });
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [needsNewPassword, setNeedsNewPassword] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const { isSignedIn, nextStep } = await signIn({
        username: formData.email,
        password: formData.password,
      });

      if (isSignedIn || nextStep?.signInStep === 'DONE') {
        setMessage('✅ Logged in.');
        return;
      }

      if (nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD') {
        // show new password field
        setNeedsNewPassword(true);
        setMessage('Set a new password to finish signing in.');
        return;
      }

      setMessage(`Next step: ${nextStep?.signInStep || 'Unknown challenge'}`);
    } catch (err) {
      console.error(err);
      setMessage(err.message || 'Login failed.');
    }
  };

  const handleSetNewPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      await confirmSignIn({ challengeResponse: formData.newPassword });
      setMessage('✅ Password updated! You are now logged in.');
      setNeedsNewPassword(false);
    } catch (err) {
      console.error(err);
      setMessage(err.message || 'Could not set new password.');
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>Log in to ChronoTech Robotics</h1>

      {message && (
        <p className={styles.message} style={{ color: message.startsWith('✅') ? 'green' : 'red' }}>
          {message}
        </p>
      )}

      {!needsNewPassword ? (
        <form onSubmit={handleSubmit} className={styles.formBox}>
          <label className={styles.formLabel}>
            Email:
            <input type="email" name="email" required value={formData.email}
                   onChange={handleChange} className={styles.formInput} />
          </label>

          <label className={styles.formLabel}>
            Password:
            <input type={showPassword ? 'text' : 'password'} name="password" required
                   value={formData.password} onChange={handleChange} className={styles.formInput} />
          </label>

          <div className={styles.passwordToggle}>
            <input type="checkbox" id="showPassword" checked={showPassword}
                   onChange={() => setShowPassword(!showPassword)} />
            <label htmlFor="showPassword">Show Password</label>
          </div>

          <ul className={styles.passwordRules}>
            <li style={{ color: /[A-Z]/.test(formData.password) ? 'green' : 'gray' }}>• One capital letter</li>
            <li style={{ color: /\d/.test(formData.password) ? 'green' : 'gray' }}>• One number</li>
            <li style={{ color: /[!@#$%^&*()_\-+=<>?{}\[\]~]/.test(formData.password) ? 'green' : 'gray' }}>• One special character</li>
            <li style={{ color: formData.password.length >= 8 ? 'green' : 'gray' }}>• At least 8 characters</li>
          </ul>

          <button type="submit" className={styles.submitButton}>Log In</button>
        </form>
      ) : (
        <form onSubmit={handleSetNewPassword} className={styles.formBox}>
          <label className={styles.formLabel}>
            New password:
            <input type="password" name="newPassword" required
                   value={formData.newPassword} onChange={handleChange}
                   className={styles.formInput} />
          </label>
          <button type="submit" className={styles.submitButton}>Set New Password</button>
        </form>
      )}
    </div>
  );
}
